import {
    API_REQUEST_SOURCE_TYPE,
    SERVICE_DELIVERY_TYPE,
} from '../../../components/sections/owners-osb/osb-constant';
import { OSBAPIResponse } from '../service-orchestration/service-adapter';
import {
    ErrorResponse,
    transformErrorResponse,
} from '../../../components/sections/owners-osb/osb-utils';
import { OSBApiService } from '../service-orchestration/osb-api-service';
import { OSB_API_PATH } from '../../../constants';
import { ServiceBookingResponse } from '../../../models/osb-model/osb-review-booking';
import { transformAmendBookingResponse } from '../../../components/sections/owners-osb/osb-service-adapters/amend-booking-adapter';
import { BookingCredentials } from '../../../models/osb-model/osb-booking-credentials';
import { Bookable } from '../../../hooks/owners-osb/use-all-osb-state';
import { ExtractValueType } from '../../../components/sections/owners-osb/osb-bookable-utils';
import { OSBStep } from '../../../models/osb-model/osb-step';

export class OSBAmendBookingClient {
    public amendServiceBooking(args: {
        dealerCode: string;
        bookingRefNo: string;
        serviceBookingRequest: Omit<Bookable, 'dealerCode'>;
        requestSourceType?: string;
        callback?: {
            (progressPercent: number): void;
            (arg0: number): void;
        };
        isMobileServiceSelected?: boolean;
        source?: ExtractValueType<OSBStep, 'source'>;
    }) {
        args.serviceBookingRequest.delivery = args.isMobileServiceSelected
            ? SERVICE_DELIVERY_TYPE.MOBILESERVICE
            : SERVICE_DELIVERY_TYPE.WORKSHOP;
        args.serviceBookingRequest.source =
            args.source || API_REQUEST_SOURCE_TYPE.WEB;

        return new Promise<OSBAPIResponse<BookingCredentials>>(
            (resolve, reject) => {
                const transformedResponse: OSBAPIResponse<BookingCredentials> = {
                    value: {} as BookingCredentials,
                    responseError: {} as ErrorResponse,
                };
                new OSBApiService()
                    .putServiceAPIOnDealerCodeBookingId<
                        Omit<Bookable, 'dealerCode'>,
                        ServiceBookingResponse
                    >(
                        args.serviceBookingRequest,
                        args.dealerCode,
                        args.bookingRefNo,
                        OSB_API_PATH.OSB_AMEND_BOOKING,
                        args.callback
                    )
                    .then(response => {
                        try {
                            transformedResponse.value = transformAmendBookingResponse(
                                response
                            );
                            resolve(transformedResponse);
                        } catch (err) {
                            transformedResponse.responseError.errorMessage =
                                'AMEND_SERVICE_BOOKING_CLIENT_TRANSFORMATION_ERROR: ' +
                                (err as Error)?.message;
                            reject(transformedResponse.responseError);
                        }
                    })
                    .catch(_error => {
                        transformedResponse.responseError = transformErrorResponse(
                            _error
                        );
                        reject(transformedResponse.responseError);
                        console.error(
                            'Rejected the promise - ',
                            transformedResponse.responseError
                        );
                    });
            }
        );
    }
}
